export default __webpack_public_path__ + "static/media/cellularNetwork.1b905209.svg";